const DataProjects = [
  {
    name: 'Stranger Things',
    Requester: 'Trybe',
    date: '22/03/2022',
    description: 'Fazer deploy de projetos de frontend e backend com o Heroku, utilizando o Docker em ambiente de produção.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Blogs API',
    Requester: 'Trybe',
    date: '16/03/2022',
    description: 'Desenvolver uma API CRUD posts de blog com o Sequelize e banco de dados MySQL.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Store Manager',
    Requester: 'Trybe',
    date: '02/03/2022',
    description: 'Desenvolver uma API de um sistema de gerenciamento de vendas utilizando a arquitetura MSC.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Talker Manager',
    Requester: 'Trybe',
    date: '21/02/2022',
    description: 'Desenvolver uma API de um CRUD de palestrantes.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'MySQL One for All',
    Requester: 'Trybe',
    date: '04/02/2022',
    description: 'Revisar uma tabela não normalizada colocando-a na 3ª forma normal. Utilizar as informações na criação de um banco de dados e executar queries solicitadas.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'MySQL All for One',
    Requester: 'Trybe',
    date: '28/01/2022',
    description: 'Aplicar conceitos de SQL aprendidos até o momento em um banco de dados chamado "Northwind".',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Docker To Do List',
    Requester: 'Trybe',
    date: '21/01/2022',
    description: 'Projeto para "conteinerizar" as aplicações de frontend, backend e testes, criando uma conexão entre elas e orquestrando seu funcionamento.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Receitas da Vovó',
    Requester: 'Trybe',
    date: '19/01/2022',
    description: 'Aplicativo de receitas de comidas e bebidas desenvolvido em grupo, na Trybe, como requisito para conclusão do módulo de Front-End.',
    gitHubLink: 'https://github.com/flavio-bianchetti/receitas-da-vovo',
    pageLink: 'https://receitasdavovo-g1.surge.sh/',
  },
  {
    name: 'StarWars Planets Search em Context API e Hooks',
    Requester: 'Trybe',
    date: '30/12/2021',
    description: 'Develop a filter list of planets from the Star Wars universe using Context API and Hooks',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Countdown - Bitcoin',
    Requester: 'Projeto pessoal',
    date: 'em desenvolvimento',
    description: 'Contador regressivo que utiliza uma API para mostrar a variação da criptomoeda Bitcoin entre o início e o fim da contagem de tempo.',
    gitHubLink: 'https://github.com/flavio-bianchetti/countdown-bitcoin',
    pageLink: 'http://countdown-bitcoin.surge.sh/',
  },
  {
    name: 'Trivia React Redux',
    Requester: 'Trybe',
    date: '07/12/21',
    description: 'Projeto baseado no jogo Trivia, utilizando React e Redux',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Trybe Wallet',
    Requester: 'Trybe',
    date: '30/11/21',
    description: 'Projeto conversor de moedas e um portifólio de acompanhamento de despesas.',
    gitHubLink: 'https://github.com/flavio-bianchetti/trybewallet-project',
    pageLink: 'https://trybewallet-project.surge.sh/',
  },
  {
    name: 'React Testing Library',
    Requester: 'Trybe',
    date: '16/11/21',
    description: 'Criação de testes para uma aplicação React',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'FrontEnd Online Store',
    Requester: 'Trybe',
    date: '04/11/21',
    description: 'Projeto em grupo para a criação de uma simples loja online, utilizando as demandas definidas em um quadro Kanban.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'TrybeTunes',
    Requester: 'Trybe',
    date: '29/10/21',
    description: 'Aplicativo capaz de reproduzir músicas, criar listas de músicas favoritas, editar perfil de usuário e outras funcionalidades.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Tryunfo',
    Requester: 'Trybe',
    date: '21/10/21',
    description: 'Desenvolvimento de um jogo no estilo Super Trunfo.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Movie Cards Library',
    Requester: 'Trybe',
    date: '13/10/21',
    description: 'Desenvolvimento de uma biblioteca de cartões de filmes utilizando React.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Asynchronous Jest and Mocking',
    Requester: 'Trybe',
    date: '01/10/21',
    description: 'Implementar testes utilizando Jest para verificar o funcionamento correto da aplicação.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Semana On-Track - Projeto: Escolha o seu Destino!',
    Requester: 'Trybe',
    date: '29/09/21',
    description: 'Projeto bônus, em grupo, desenvolvido em HTML, CSS e JavaScript, que utiliza a API da NASA para exibição de imagens de planetas.',
    gitHubLink: 'https://github.com/flavio-bianchetti/nasa-api-project',
    pageLink: 'https://nasa-api-project.surge.sh/',
  },
  {
    name: 'Shopping Cart',
    Requester: 'Trybe',
    date: '27/09/21',
    description: 'Desenvolver um carrinho de compras consumindo dados diretamente de uma API.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Zoo Functions',
    Requester: 'Trybe',
    date: '21/09/21',
    description: 'Implementar várias funções para atender aos requisitos propostos e garantir que todas as funções passem nos testes unitários.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'JS Unit Tests',
    Requester: 'Trybe',
    date: '08/09/21',
    description: 'Implementar várias funções para atender aos requisitos propostos e/ou testes unitários para garantir que as implementações de funções estejam corretas.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Trybewarts',
    Requester: 'Trybe',
    date: '02/09/21',
    description: 'Desenvolva uma página de formulário da Trybewarts Wizarding School onde os alunos possam enviar comentários sobre ela.',
    gitHubLink: 'https://github.com/flavio-bianchetti/trybewarts-project',
    pageLink: 'http://trybewarts-project.surge.sh/',
  },
  {
    name: 'Meme Generator',
    Requester: 'Trybe',
    date: '24/08/21',
    description: 'Desenvolva um site onde você pode produzir fotos para memes.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Pixels Art',
    Requester: 'Trybe',
    date: '24/08/21',
    description: 'Implemente uma paleta de cores usando JavaScript, CSS e HTML.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'To-Do List',
    Requester: 'Trybe',
    date: '24/08/21',
    description: 'Desenvolva uma lista de tarefas usando HTML, CSS e JavaScript.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Mistery Letter',
    Requester: 'Trybe',
    date: '24/08/21',
    description: 'Desenvolva um aplicativo usando JavaScript, HTML5 e CSS3.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Color Guess',
    Requester: 'Trybe',
    date: '24/08/21',
    description: 'Desenvolva um aplicativo usando JavaScript, HTML5 e CSS3.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Playground Functions',
    Requester: 'Trybe',
    date: '11/08/21',
    description: 'Implementar funções de requisitos.',
    gitHubLink: '',
    pageLink: '',
  },
  {
    name: 'Lessons Learned',
    Requester: 'Trybe',
    date: '03/08/21',
    description: 'Desenvolva uma página HTML estilizada com CSS.',
    gitHubLink: 'https://github.com/flavio-bianchetti/lessons-learned-project',
    pageLink: 'https://fjb-lessons-learned-trybe.surge.sh/',
  },
];

export default DataProjects;
